import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { ref } from "vue"
import { SizeNameMap, SizeStyleMap } from "./infoConfig"
import { useStorage } from "@vueuse/core"


export default /*@__PURE__*/_defineComponent({
  __name: 'SizeTag',
  props: {
    modelValue: { default: SizeStyleMap["small"] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const currentSize = ref("small")
const fontSizes = ["small", "medium", "large"]
const fontStyle = ref(props.modelValue)
const selectOptionsVisible = ref(false)
const aiTheme = useStorage("ai-theme", "brown")

function changeFontStyle(size: string) {
  currentSize.value = size
  fontStyle.value = SizeStyleMap[size]
  emits("update:modelValue", fontStyle.value)
  changeFontSize()
}

function changeFontSize() {
  selectOptionsVisible.value = !selectOptionsVisible.value
}

return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "change-size cursor-pointer ml-3",
    onClick: changeFontSize
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      id: "size-button",
      class: "flex-column align-center justify-center"
    }, [
      _createElementVNode("i", { class: "iconfont icon-daxiao right-bar_icon cursor-pointer" }),
      _createElementVNode("span", { class: "operate-text" }, "大小")
    ], -1)),
    _createVNode(_component_ion_popover, {
      "is-open": selectOptionsVisible.value,
      arrow: false,
      "show-backdrop": false,
      trigger: "size-button",
      "trigger-action": "click",
      class: "size-popover"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-row justify-evenly", _unref(aiTheme)])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fontSizes, (size, index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: _normalizeClass(["mt-2 mb-2 mr-2 ml-2 cursor-pointer", { 'font-size-selected': size === currentSize.value }]),
                  onClick: ($event: any) => (changeFontStyle(size))
                }, _toDisplayString(_unref(SizeNameMap)[size]), 11, _hoisted_1)
              }), 64))
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})